class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.loading = false;
  }

  connectedCallback() {
    // Only load when the user actually interacts with quick view or the product card
    const details = this.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open) {
          this.loadContent();
        }
      });
    }

    // Listen for custom open event dispatched by quick-view-button
    this._openHandler = (e) => {
      if (e.detail && e.detail.productUrl === this.dataset.productUrl) {
        this.loadContent();
      }
    };
    document.addEventListener('quickview:open', this._openHandler);
  }

  disconnectedCallback() {
    if (this._openHandler) {
      document.removeEventListener('quickview:open', this._openHandler);
    }
  }

  loadContent() {
    if (this.loaded || this.loading) return;
    this.loading = true;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    if (!drawerContent || !this.dataset.productUrl) {
      this.loading = false;
      return;
    }

    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = responseHTML.querySelector(selector);
        if (productElement) {
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }

        this.loaded = true;
        this.loading = false;
        drawerContent.classList.add('hide-cover');

        document.dispatchEvent(new CustomEvent('quickview:loaded', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      })
      .catch(e => {
        this.loading = false;
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
